/** Eenmalige swipe-peek op de eerste Today-mobielrij; schrijft swipeTeaser na animatie. */
import { useCallback, useEffect, useRef, useState } from 'react';
import { ONBOARDING_HINT_SWIPE_TEASER } from '@/constants/onboardingHints';
import { useTier } from '@/features/tier/useTier';
import { markHintSeen } from '@/services/userService';

/**
 * @param {Object} params
 * @param {boolean} params.isBattlefield
 * @param {string[]} params.todayTaskIds
 * @param {string | undefined} params.userId
 */
export function useTodaySwipeTeaserHint({
  isBattlefield,
  todayTaskIds,
  userId,
}) {
  const { seenHints, profileLoaded } = useTier();
  const markedRef = useRef(false);
  const [teaserActive, setTeaserActive] = useState(false);

  const firstTaskId = todayTaskIds[0] ?? null;
  const hintSeen = seenHints.includes(ONBOARDING_HINT_SWIPE_TEASER);
  const eligible =
    isBattlefield &&
    Boolean(firstTaskId) &&
    profileLoaded &&
    Boolean(userId) &&
    !hintSeen;

  useEffect(() => {
    if (!eligible || markedRef.current) {
      return;
    }

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches;
    if (reducedMotion) {
      markedRef.current = true;
      void markHintSeen(userId, ONBOARDING_HINT_SWIPE_TEASER);
      return;
    }

    setTeaserActive(true);
  }, [eligible, userId]);

  const onSwipeTeaserEnd = useCallback(() => {
    if (!userId || markedRef.current) {
      return;
    }
    markedRef.current = true;
    setTeaserActive(false);
    void markHintSeen(userId, ONBOARDING_HINT_SWIPE_TEASER);
  }, [userId]);

  const swipeTeaserTaskId =
    teaserActive && firstTaskId ? firstTaskId : null;

  return { swipeTeaserTaskId, onSwipeTeaserEnd };
}
